import { QueryClient } from "@tanstack/vue-query";

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        networkMode: "always",
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
      },
      mutations: {
        retry: false,
        networkMode: "always",
      },
    },
  });
}

export const queryClient = createQueryClient();
